import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { FormFieldSubentity } from './form-field-subentity'
import { FormSubmitButtonSubentity } from './form-submit-button-subentity'
import { FormCheckboxSubentity } from './form-checkbox-subentity'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { CommonForm } from 'src/shared/entities/form'
import { FormSubentityTypeEnum } from 'src/shared/types/entities/form-interface'

export interface FormProps {
  entity: FormInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const Form = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: FormProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonForm entity={entity}>
        {entity.subEntities.map(subentity => {
          if (subentity.type === FormSubentityTypeEnum.Field) {
            return (
              <FormFieldSubentity
                key={subentity.id}
                formEntity={entity}
                fieldSubentity={subentity}
              />
            )
          } else if (subentity.type === FormSubentityTypeEnum.Checkbox) {
            return (
              <FormCheckboxSubentity
                key={subentity.id}
                formEntity={entity}
                checkboxSubentity={subentity}
              />
            )
          } else {
            return (
              <FormSubmitButtonSubentity
                key={subentity.id}
                formEntity={entity}
                submitButtonSubentity={subentity}
              />
            )
          }
        })}
      </CommonForm>
    </BaseEntityNew>
  )
}
